module.exports = __webpack_public_path__ + "static/img/jiantou.d04d43a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daping/jiantou.png
// module id = TuMH
// module chunks = 0